/**
 * Formats a date to a readable label for chat grouping
 * @param {Date|string} date - The date to format (ISO string or Date object)
 * @returns {string} "Today", "Yesterday", or formatted date string
 */
export function getFormattedDateLabel(date) {
    const now = new Date();
    const targetDate = new Date(date);

    // Reset time to midnight for accurate day comparison
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const targetStart = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());

    const diffDays = Math.floor((targetStart - todayStart) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
        return 'Today';
    } else if (diffDays === -1) {
        return 'Yesterday';
    } else {
        // Format: "Fri Apr 03 2026"
        return targetDate.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    }
}

/**
 * Checks if two dates are on the same day
 * @param {Date|string} date1
 * @param {Date|string} date2
 * @returns {boolean}
 */
export function isSameDay(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    return d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate();
}
